export default __webpack_public_path__ + "static/media/news-app.9d7bec40.jpg";